





























import { Component } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import JournalEntry from '@/models/Accounting/JournalEntries/JournalEntry';
import PageNames from '@/router/PageNames';

@Component({ name: 'GeneralLedgerAccountJournalEntries' })
export default class extends SaascadaVue {

    // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
    headers = [
        { text: this.$t('pageText.journalEntries.fields.date'), value: 'date', sortable: false, width: '10%' },
        { text: this.$t('pageText.journalEntries.fields.eventType'), value: 'eventType', sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.transactionType'), value: 'transactionType', sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.debitAccount'), sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.debitAmount'), sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.creditAccount'), sortable: false, width: '15%' },
        { text: this.$t('pageText.journalEntries.fields.creditAmount'), sortable: false, width: '15%' }
    ];
    search = '';
    journalEntriesPage = 1;

    async beforeMount() {
        await GeneralLedgerAccountsModule.getGeneralLedgerAccountJournalEntries(this.$route.params.id);
    }

    get journalEntries() {
        return GeneralLedgerAccountsModule.generalLedgerAccountJournalEntries;
    }

    get totalJournalEntriesPages() {
        return GeneralLedgerAccountsModule.totalGeneralLedgerAccountJournalEntriesPages;
    }

    get loading() {
        return false;
    }

    get pageSize() {
        return GeneralLedgerAccountsModule.pageSize;
    }

    async navigateToJournalEntry(journalEntry: JournalEntry) {
        this.$router.push({ name: PageNames.JournalEntry, params: { id: journalEntry.id } });
    }

}
